var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28","width":"28","height":"28"}},[_c('path',{attrs:{"fill":"currentColor","d":"M19 6h-1v7v9h1v-3h3v-1h-3V6ZM11 7h-1v16h1V10h3V9h-3V7Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }